import "./map.css"

import { ReactNode } from "react";
import { MapContainer, MapContainerProps, TileLayer } from "react-leaflet";

function GoogleMap<Props extends MapContainerProps = MapContainerProps>({
    children,
    scrollWheelZoom = true,
    zoomControl = true,
    ...otherProps
}: Props): ReactNode {
    return (
        <MapContainer
            className={"map google-map"}
            scrollWheelZoom={scrollWheelZoom}
            zoomControl={zoomControl}
            {...otherProps}
        >
            {/* Тайлы обязаны идти по https: на https-странице браузер режет
                http-запросы как mixed content, и карта остаётся пустой. */}
            <TileLayer
                attribution='&copy; google contributors'
                url="https://{s}.google.com/vt/lyrs=s,p&x={x}&y={y}&z={z}"
                subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
            />
            {children}
        </MapContainer>
    )
}

export default GoogleMap;